import { useTranslation } from 'react-i18next'
import { useContext } from 'react'
import { HomeContext } from '../state/home-context'
import { useApiGetTargetProductivity } from '../../../core/api/home/productivity/useApiGetTargetProductivity'
import { useApiGetGmvEvaluation } from '../../../core/api/home/useApiGetGmvEvaluation'
import AnnualCommitmentMonitoring from './annual-commitment-monitoring/annual-commitment-monitoring'
import CumulativeChart from './cumulative-chart/cumulative-chart'
import YearlyGraphBadge from './yearly-graph-badge'
import YearlyGraphExplanations from './yearly-graph-explanations'
import Productivity from './productivity/productivity'
import TargetProductivityEdition from './productivity/target-productivity-edition'
import { isHomeApiEnabled } from 'core/api/home/home-api-utils'

const Yearly = () => {
  const { t } = useTranslation()
  const { aggregation, channel, storeId, teamId, store } = useContext(HomeContext)
  const currency = store?.currency
  const { data: targetProductivity } = useApiGetTargetProductivity(
    { storeId, teamId, channel, aggregation },
    isHomeApiEnabled(storeId, teamId, aggregation) && channel === 'INSTORE'
  )
  const { data: gmvEvaluation } = useApiGetGmvEvaluation(
    { storeId, teamId, channel, aggregation },
    isHomeApiEnabled(storeId, teamId, aggregation)
  )

  const isIndeterminate =
    gmvEvaluation?.yearToDateEvaluation === 'INDETERMINATE' && gmvEvaluation?.yearEvaluation === 'INDETERMINATE'

  return (
    <section data-testid="yearly" className="mg-yearly">
      <header className="yearly-header">
        <div className="yearly-title">
          <span className="vp-subtitle-l">{t('general.homepage.yearly')}</span>
          {!isIndeterminate && (
            <YearlyGraphBadge
              yearToDateEvaluation={gmvEvaluation?.yearToDateEvaluation}
              yearEvaluation={gmvEvaluation?.yearEvaluation}
            />
          )}
        </div>

        <div className="yearly-button">
          {channel === 'INSTORE' && (
            <TargetProductivityEdition targetProductivity={targetProductivity?.value}></TargetProductivityEdition>
          )}
        </div>
      </header>

      <div className="yearly-data-section">
        <div className="yearly-description-container">
          <div className="vp-caption yearly-description-text">
            {!isIndeterminate && (
              <YearlyGraphExplanations
                yearToDateEvaluation={gmvEvaluation?.yearToDateEvaluation}
                yearEvaluation={gmvEvaluation?.yearEvaluation}
                forecastTrajectoryGap={gmvEvaluation?.forecastTrajectoryGap}
                currency={currency}
              />
            )}
          </div>

          <CumulativeChart />
        </div>

        <div className="yearly-cards-container">
          <div className="yearly-card-container">
            <Productivity targetProductivity={targetProductivity?.value} />
            <AnnualCommitmentMonitoring />
          </div>
        </div>
      </div>
    </section>
  )
}

export default Yearly
